import { render, staticRenderFns } from "./PrivateMessageNotification.vue?vue&type=template&id=458b415c"
import script from "./PrivateMessageNotification.vue?vue&type=script&lang=ts"
export * from "./PrivateMessageNotification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports